import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import {
  IComboBase,
  IComboBaseCountry,
} from '../../../interfaces/base/base.interface';
import { ManagementService } from '../../services/management.service';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { CityService } from '../../../services/city.service';
import { CountryService } from '../../../services/country.service';

@Component({
  selector: 'app-city-register-modal',
  templateUrl: './city-register-modal.component.html',
  styleUrl: './city-register-modal.component.scss',
  providers: [DialogService],
})
export class CityRegisterModalComponent {
  @Input() visible: boolean = false;
  @Input() countryId: number | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerCityComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  country: string | null = null;
  city: string | null = null;
  isLoading: boolean = false;
  selectedCountry: IComboBaseCountry | null = null;
  filteredOptions: IComboBase[] = [];
  countries: IComboBaseCountry[] = [];

  hasInteracted: { [key: string]: boolean } = {
    country: false,
    city: false,
  };

  constructor(
    private managementService: ManagementService,
    private countryService: CountryService,
    private cityService: CityService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryId'] && changes['countryId'].currentValue !== null) {
      this.loadCountryData();
    }
  }

  private loadCountryData(): void {
    this.isLoading = true;
    if (!this.countryId) return;

    this.countryService.comboCountry().subscribe({
      next: (countries) => {
        console.log('countries: ', countries);
        this.selectedCountry =
          countries.find(
            (country) => String(country.key) === String(this.countryId)
          ) || null;
        console.log('Selected country: ', this.selectedCountry);

        if (this.selectedCountry) {
          this.country = this.selectedCountry.text;

          this.cityService.comboCity(String(this.countryId)).subscribe({
            next: (cities) => {
              this.isLoading = false;
              this.validateForm();
            },
            error: (err) => {
              this.isLoading = false;
              console.error('Error al obtener ciudades:', err);
            },
          });
        } else {
          this.isLoading = false;
          console.warn('País no encontrado con ID:', this.countryId);
        }

        this.filteredOptions = countries;
        this.hasInteracted['country'] = true;
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error al obtener países:', err);
      },
    });
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'country':
        this.selectedCountry = null;
        break;
      case 'city':
        this.city = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  filterOptions(event: any, type: string) {
    const query = event.query.toLowerCase();
    let options: IComboBase[] = [];
    switch (type) {
      case 'country':
        options = this.countries;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.filteredOptions = options.filter((option) =>
      option.text.toLowerCase().includes(query)
    );
  }

  onSelect(event: any, type: string) {
    this.hasInteracted[type] = true;

    switch (type) {
      case 'country':
        this.selectedCountry = event.value ?? null;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }

    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.selectedCountry && this.city);
  }

  onRegister() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const request = {
      nameCity: this.city,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.managementService
      .createCity(formData, Number(this.countryId))
      .subscribe({
        next: (response) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'La ciudad se ha registrado con éxito.',
              title: '¡Éxito!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.registerCityComplete.emit();
          this.closeDialog();
        },

        error: (err) => {
          loadingRef.close();

          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.resetForm();
          this.closeDialog();
        },
      });
    this.closeDialog();
  }

  resetForm() {
    this.city = null;
    this.hasInteracted = {
      country: false,
      city: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }
}
